import { useMemo } from "react";
import { roundCredits } from "../../../utills/common";
import { PRODUCTS, TEST_TYPE_TASK } from "../../../actions/constants";
import { useAuthContext } from "../../user/AuthProvider";
import { Flex, Tag, Tooltip, Typography } from "antd";
import CustomIcon from "../../layouts/CustomIcon";

const { Text } = Typography;

const HoverTooltip = ({ children, seg }) => {
  const { name, color, value } = seg || {};

  return (
    <Tooltip
      trigger='hover'
      placement='bottom'
      styles={{ container: { width: "250px", padding: "10px 20px" } }}
      title={
        <Flex vertical gap={10}>
          <Flex align='center' justify='space-between'>
            <Text className='font-size-12px color-A9A9BC'>Research Method</Text>
            <Text className='font-size-12px color-A9A9BC'>Credits</Text>
          </Flex>

          <Flex align='center' justify='space-between'>
            <Flex align='center' gap={5} className='w-75'>
              <Tag className='border-radius-circle w-10px h-10px p-0' style={{ backgroundColor: color, borderColor: color }}></Tag>
              <Text className='text-white font-size-12px w-90'>{name}</Text>
            </Flex>
            <Text className='text-white font-size-12px'>{roundCredits(value)}</Text>
          </Flex>
        </Flex>
      }
    >
      {children}
    </Tooltip>
  );
};

export default function PooledCreditUsageProgressBar({ height = 12, multipleWorkspaces = false, individualDashboard = false }) {
  const { products, creditUsage, planInfo, subscription, organization, usedPercentage } = useAuthContext();
  const { isCustomPlan, isTrialPlan, balances } = planInfo || {};
  const { own_users } = subscription?.plan || {};
  const { credits_response_total, credits_response_permanent } = organization || {};
  const { credits: { used: { stripeMeter } = {} } = {} } = balances || {};

  const productUsages = useMemo(() => {
    const segments = [];
    let total = 0;

    products?.forEach(({ key, name, color, type, isNoRecording }) => {
      const productType = type === TEST_TYPE_TASK && isNoRecording ? PRODUCTS.NORECORDING : type;
      const value = roundCredits(creditUsage?.usage?.usedCredit?.[productType]);

      segments.push({
        key,
        name,
        color,
        type,
        isNoRecording,
        productType,
        value,
      });

      total += value;
    });

    return { segments, total };
  }, [creditUsage?.usage, products]);

  const { segments, total } = productUsages;

  const totalBar =
    isCustomPlan || isTrialPlan
      ? multipleWorkspaces
        ? total
        : Number(total + credits_response_total)
      : total > own_users + credits_response_permanent
      ? total
      : own_users + credits_response_permanent;

  return (
    <div
      className='segbar-outer bg-white position-relative'
      style={{
        height,
        boxShadow: "0 0 0 1px #DAE3FB",
      }}
    >
      <div className='segbar-inner' style={{ height }}>
        {segments.map((seg) => {
          const percent = (seg.value / totalBar) * 100;
          return (
            <HoverTooltip seg={seg} key={seg.key}>
              <div
                key={seg.key}
                className='segbar-segment'
                style={{
                  width: `${percent}%`,
                  backgroundColor: seg.color,
                }}
              />
            </HoverTooltip>
          );
        })}
      </div>
      {usedPercentage >= 100 && Number(stripeMeter) > 0 && (
        <div className='position-absolute top-0 right-n10px'>
          <CustomIcon name='line' />
        </div>
      )}
    </div>
  );
}
